module.exports = __webpack_public_path__ + "static/logo_dark_fischer_marmor_website.b1dca867.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_dark_fischer_marmor_website.png
// module id = 750
// module chunks = 114276838955818